<template>
	<div class="">
		<div class="bg-black cl-w px-4  py-5  border-top">
			<footer class="row row-cols-1 row-cols-sm-2 row-cols-md-6">
				<div class="col mb-3 h1 ftw900">
					<!-- MiraStudent -->
					{{$t('common.webName')}}
				</div>
				<div class=" mb-3 ">
					<h5 class="cl-w"><a href="#/aboutUs?type=1" class="nav-link p-0 text-muted">{{$t('footers.about')}}</a></h5>
					<ul class="nav flex-column">
						<li class="nav-item mb-2"><a href="#/aboutUs?type=2" class="nav-link p-0 text-muted">{{$t('footers.pavilionToUs')}}</a></li>
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.primarySchool')}}</a></li>
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.ascoretest')}}</a></li>
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.dse')}}</a></li>
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.juniorHighSchool')}}</a></li>
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.ib')}}</a></li>
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.alevel')}}</a></li>
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.igcse')}}</a></li>
					</ul>
					<h5 class="cl-w mt-3"><a href="#/contactUs" class="nav-link p-0 text-muted">{{$t('footers.contactUs')}}</a></h5>
					<div>cs@mirastudent.com</div>
				</div>
		
				<div class=" mb-3">
					<h5 class="cl-w">{{$t('footers.Astudent')}}</h5>
					<ul class="nav flex-column">
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.used')}}</a></li>
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.trialDiscounts')}}</a></li>
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.serviceGuarantee')}}</a></li>
						<li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">{{$t('footers.refund')}}</a></li>
					</ul>
				</div>
				<div class=" mb-3">
					<h5 class="cl-w">{{$t('footers.ATeacher')}}</h5>
					<ul class="nav flex-column">
						<li class="nav-item mb-2"><a href="#/beforeBecomeTeacher" class="nav-link p-0 text-muted">{{$t('footers.becomeTeacher')}}</a></li>
						<li class="nav-item mb-2 clickAct"  @click="showModal = true">{{$t('footers.recommendedTeacherProgram')}}</li>
					</ul>
				</div>
		
				<div class=" mb-3">
					<h5 class="cl-w">{{$t('footers.help')}}</h5>
					<ul class="nav flex-column">
						<li class="nav-item mb-2"><a href="#/problem" class="nav-link p-0 text-muted">{{$t('footers.questions')}}</a></li>
					</ul>
					<h5 class="cl-w mt-3">{{$t('footers.termsofService')}}</h5>
					<ul class="nav flex-column">
						<li class="nav-item mb-2"><a href="#/textTerms" class="nav-link p-0 text-muted">{{$t('footers.termsofUse')}}</a></li>
						<li class="nav-item mb-2"><a href="#/textTerms" class="nav-link p-0 text-muted">{{$t('footers.privacyPolicy')}}</a></li>
						<li class="nav-item mb-2"><a href="#/textTerms" class="nav-link p-0 text-muted">{{$t('footers.cookie')}}</a></li>
					</ul>
				</div>
				<div class=" mb-3">
					<h5 class="mb-4 cl-w">{{$t('footers.socialize')}}</h5>
					<img src="../assets/image/footers/footer-ph1.png" alt="" class="footers-photo" />
					<img src="../assets/image/footers/footer-ph2.png" alt="" class="footers-photo" />
					<img src="../assets/image/footers/footer-ph3.png" alt="" class="footers-photo" />
				</div>
				
			</footer>
			<div class="text-center mt-4">
				<div>
					MiraStudent.com 為 Mira Talker Limited 的旗下品牌，是香港的科技服務供應商之一
				</div>
				<div>
					Copyright © 2025 Mira Talker Limited 版權所有。
				</div>
				<div>
					網站營運及持有者： Mira Talker Limited 
				</div>
			</div>
			
			<a-modal :title="null" v-model="showModal" :footer="null" @cancel="showModal=false">
				<div>
					<div class="text-center ftr-1-25 ftw600 border-b pb-3 wid-100">
						{{$t('footers.modal1')}}
					</div>
					<div class="ftw600 mt-3 cl-black">
						{{$t('footers.modal2')}}
					</div>
					<div>
						{{$t('footers.modal3')}}
					</div>
					<div class="ftw600 mt-3 cl-black">
						{{$t('footers.modal4')}}
					</div>
					<div>
						{{$t('footers.modal5')}}
					</div>
					
					<div class="ftw600 mt-3 cl-black">
						{{$t('footers.modal6')}}
					</div>
					<div class="mt-2">
						1. {{$t('footers.modal7')}}
					</div>
					<div class="mt-2">
						2. {{$t('footers.modal8')}}
					</div>
					<div class="mt-2">
						3. {{$t('footers.modal9')}}
					</div>
					
					<div class="flex center mt-4">
						<div class="btn btn-outline-theme" style="width: 100px;" @click="showModal=false">
							{{$t('common.leave')}}
						</div>
					</div>
				</div>
			</a-modal>
			
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				showModal:false
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
	.text-muted{
		color: #fff !important;
	}
	.footers-photo{
		width: 70px;
		height: 70px;
		border-radius: 50%;
		margin-left: 10px;
	}
</style>